import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { useFelaEnhanced } from '@ackee/fela';

import { Text, TextTypes, TitleTypes, Title } from 'modules/ui';
import type { MessageKey } from 'modules/intl';

import * as felaRules from './SingleOffice.rules';

export interface SingleOfficeProps {
    content: {
        title: MessageKey;
        street: MessageKey;
        city: MessageKey;
        country: MessageKey;
        icon: () => ReactNode;
    };
}

export const SingleOffice = ({ content }: SingleOfficeProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);
    const { title, street, city, country } = content;

    return (
        <div className={styles.officeContainer}>
            {content.icon()}
            {/* @ts-expect-error */}
            <Title extend={{ title: rules.extendTitle }} as={TitleTypes.H3} type={TitleTypes.H3_ITALIC}>
                <FormattedMessage id={title} />
            </Title>
            {/* @ts-expect-error */}
            <Text extend={{ text: rules.extendAddressText }} type={TextTypes.PARAGRAPH}>
                <FormattedMessage id={street} />
            </Text>
            {/* @ts-expect-error */}
            <Text extend={{ text: rules.extendAddressText }} type={TextTypes.PARAGRAPH}>
                <FormattedMessage id={city} />
            </Text>
            {/* @ts-expect-error */}
            <Text extend={{ text: rules.extendAddressText }} type={TextTypes.PARAGRAPH}>
                <FormattedMessage id={country} />
            </Text>
        </div>
    );
};
